import { render, staticRenderFns } from "./DataHubPage.vue?vue&type=template&id=611448af&scoped=true"
import script from "./DataHubPage.vue?vue&type=script&lang=js"
export * from "./DataHubPage.vue?vue&type=script&lang=js"
import style0 from "./DataHubPage.vue?vue&type=style&index=0&id=611448af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611448af",
  null
  
)

export default component.exports